import { render } from "./ActionCardInscription.vue?vue&type=template&id=5600baeb"
import script from "./ActionCardInscription.vue?vue&type=script&lang=js"
export * from "./ActionCardInscription.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__